import { flow } from 'fp-ts/lib/function';
import { iso } from 'newtype-ts';
import { hasProp } from '../../hasProp';
import * as CanonicalProduct from '../product'; // as opposed to this module's Product which is a ConfigurationProduct
const _ = iso();
export const construct = (c) => _.wrap({ ...c, tag: 'Configuration' });
export const product = (c) => _.unwrap(c).product;
// TODO: consider a lens here
export const productId = flow(product, CanonicalProduct.id);
export const is = (u) => {
    if (typeof u === 'object' && u !== null && hasProp(u, 'tag')) {
        return u.tag === 'Configuration';
    }
    return false;
};
